import axiosInstance from "../../axios/instance";
import { getToken } from "../../helpers/get-token";

async function createCustomer(values) {
    try {
        const token = getToken();
        const response = await axiosInstance.post('/api/clients-accounts', values, {
            headers: {
                'Authorization': token
            }
        });

        return response?.data;
    } catch (error) {
        console.log(error);
        throw error; // Re-throw the error for further handling if needed
    }
}

export default createCustomer;
